module.exports = __webpack_public_path__ + "img/document-text.5b36bd21.svg";